import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const appStore = new Vuex.Store({
  state: {
    name: '',
    config: {},
    profile: {},
    products: {},
    locale: 'ru'
  },

  mutations: {
    setValue (state, keyValue) {
      state[keyValue.key] = keyValue.value
    }
  },

  actions: {
    setValue ({commit}, keyValue) {
      commit('setValue', keyValue)
    }
  },

  getters: {
    value: state => key => {
      if (key in state) {
        return state[key]
      } else {
        return null
      }
    }
  }
})

export default appStore



// WEBPACK FOOTER //
// ./src/storages/appStore.js